import { FC, useContext, useEffect } from "react";

import { FormInstance } from "antd";

import { RowSize, ColSize, ContentSection } from "../../../../../../shared/components";

import { PreLiquidationsFilter } from "../PreLiquidationsFilter";
import { PreLiquidationsTable } from "../PreLiquidationsTable";
import { PreLiquidationsFilterForm } from "../../interfaces";
import { SavedAndSentPreLiquidationsContext } from "../../contexts/SavedAndSentPreLiquidations";

import './index.css';
interface SavedAndSentPreLiquidationTabProps {
    filterForm:                 FormInstance<PreLiquidationsFilterForm>;
    isSavedPreliquidations?:    boolean;
};

export const SavedAndSentPreLiquidationTab: FC<SavedAndSentPreLiquidationTabProps> = ({
    filterForm,
    isSavedPreliquidations = false,
}) => {
    const {
        getSavedPreliquidations,
        getSentPreliquidations,
    } = useContext(SavedAndSentPreLiquidationsContext);

    useEffect(() => {
        if(isSavedPreliquidations) {
            getSavedPreliquidations();
        } else {
            getSentPreliquidations();
        }
        /* eslint-disable-next-line */
    }, [])

    return (
        <RowSize className="container-saved-and-sent-preliquidation-tab">
            <ColSize size={100}>
                <RowSize className="container-section-preliquitdation-tab">
                    <PreLiquidationsFilter 
                        filterForm={filterForm} 
                        isSavedPreliquidations={isSavedPreliquidations}
                    />
                </RowSize>
            </ColSize>
            
            <ColSize size={100}>
                <RowSize className="container-section-preliquitdation-tab">
                    <PreLiquidationsTable 
                        isSavedPreliquidations={isSavedPreliquidations} 
                    />
                </RowSize>
            </ColSize>
        </RowSize>
    )
}
